import { defineMessages } from 'react-intl'

export default defineMessages({
  contactHeadline: 'Do not hesitate and lay the foundation stone for the future today',
  labelName: 'Your name',
  labelFreetext: 'Your message',
  labelFile: 'Your file',
  placeholderName: 'Name *',
  labelCompany: 'Your company',
  placeholderCompany: 'Company *',
  labelPhone: 'Your telephone number',
  placeholderPhone: 'Phone number',
  labelMail: 'Your e-mail address',
  placeholderMail: 'E-Mail *',
  placeholderFreetext: 'Drop us a line with your needs...',
  checkboxText: "I accept the '<a href=\"/en/privacy-policy/\" target=\"_blank\">privacy policy</a>' *",
  labelButton: 'Send request now',
  requiredTextInput: 'Please fill in this field',
  requiredCheckbox: 'Please tick this box if you want to proceed'
})

